// extracted by mini-css-extract-plugin
module.exports = {"ZyTable":"ZyTable_ZyTable_2sU8f"};